import { useContext, useState } from "react";
import UserContext from "../context/user";
import AppsLogin from "./apps-login";
import Header from "../components/header";
import Footer from "../components/footer";
import CmsPage from "../components/cms-page";
import CookiePolicy from "./cookie-policy";
import ForgotPassword from "./forgot-password";
import CookieBanner from "../components/cookie-banner";
import CarrelloBody from "../components/cart/cart-body";
import useTealiumOnPageLoad from "../utils/tealium";
import useDocumentTitle from "../hooks/useDocumentTitle";
import CartContext from "../context/cart";
import AppError from "../components/app-error";

const APP = "CARRELLO_DELLA_SPESA";

const CarrelloDellaSpesa = () => {
  const { logged } = useContext(UserContext);
  const {
    survey,
    error,
    labels,
    status,
    navigation,
    setNavigation,
    appLang,
    setAppLang,
    languages,
  } = useContext(CartContext);
  const [forgotPw, setForgotPw] = useState();

  useTealiumOnPageLoad({ pageSection1: "welfare", pageSection2: "Carrello della spesa" });
  useDocumentTitle("EssilorLuxottica Carrello della Spesa");

  return (
    <>
      {logged ? (
        Object.entries(labels).length === 0 ? (
          <div className="loading-spinner mt" />
        ) : (
          <>
            <Header
              selectedLanguage={appLang}
              setSelectedLanguage={setAppLang}
              languages={languages}
              labels={labels}
              app={APP}
              appTitle={survey?.title}
            />
            <main className="carrello-content">
              {["privacy-policy", "cookie-policy"]?.includes(navigation) ? (
                {
                  "privacy-policy": (
                    <CmsPage
                      path="footer/privacy-policy"
                      title={labels?.WELFARE_PRIVACY_POLICY}
                      setNavigation={setNavigation}
                      key={navigation}
                      appLang={appLang}
                    />
                  ),
                  "cookie-policy": (
                    <CookiePolicy logged={true} setNavigation={setNavigation} appLang={appLang} />
                  ),
                }[navigation]
              ) : error ? (
                <AppError error={error} labels={labels} />
              ) : !survey && status !== "invalid-campaign" ? (
                <div className="loading-spinner mt" />
              ) : (
                <CarrelloBody />
              )}
            </main>
            <Footer setNavigation={setNavigation} app={APP} labels={labels} />
          </>
        )
      ) : forgotPw ? (
        <ForgotPassword setForgotPw={setForgotPw} labels={labels} />
      ) : navigation === "cookie-policy" ? (
        <CookiePolicy logged={false} setNavigation={setNavigation} appLang={appLang} />
      ) : (
        <AppsLogin app={APP} setForgotPw={setForgotPw} labels={labels} />
      )}
      <CookieBanner labels={labels} setNavigation={setNavigation} />
    </>
  );
};

export default CarrelloDellaSpesa;
